import Seo from "@/components/feature/Seo";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import ContactSection from "@/pages/about/components/ContactSection";

const values = [
  { icon: "ri-heart-3-line", color: "bg-secondary-100 text-secondary-600", title: "热爱动漫", desc: "我们本身就是动漫爱好者，更懂你真正想看什么。" },
  { icon: "ri-eye-line", color: "bg-primary-100 text-primary-600", title: "内容优质", desc: "每一篇资讯都经过用心筛选与打磨，宁缺毋滥。" },
  { icon: "ri-flashlight-line", color: "bg-accent-100 text-accent-600", title: "快速直达", desc: "优化的直达链接与导航结构，让你一步到位不迷路。" },
  { icon: "ri-team-line", color: "bg-background-200 text-foreground-700", title: "开放共建", desc: "欢迎投稿与建议，动漫网与你共同成长。" },
];

const reviews = [
  { name: "追番小能手", role: "动漫爱好者", avatar: "https://readdy.ai/api/search-image?query=Stylized%20anime%20avatar%20portrait%20of%20a%20smiling%20young%20girl%20with%20orange%20hair%20and%20energetic%20expression%2C%20clean%20coral%20background%2C%20artistic%20digital%20illustration%2C%20high%20detail%2C%20soft%20lighting&width=200&height=200&seq=avatar-01&orientation=squarish", text: "动漫网的分类特别全，想找哪类新番直接点进去就行，收藏一次之后每天都来看，方便极了！" },
  { name: "漫游星海", role: "资深二次元", avatar: "https://readdy.ai/api/search-image?query=Stylized%20anime%20avatar%20portrait%20of%20a%20calm%20young%20man%20with%20teal%20hair%20and%20glasses%2C%20clean%20teal%20background%2C%20artistic%20digital%20illustration%2C%20high%20detail%2C%20soft%20lighting&width=200&height=200&seq=avatar-02&orientation=squarish", text: "资讯更新很及时，新番前瞻写得也用心，很多冷门好番都是在这里发现的，强烈推荐！" },
  { name: "动漫杂货铺", role: "内容创作者", avatar: "https://readdy.ai/api/search-image?query=Stylized%20anime%20avatar%20portrait%20of%20a%20friendly%20person%20with%20pink%20hair%20and%20warm%20smile%2C%20clean%20peach%20background%2C%20artistic%20digital%20illustration%2C%20high%20detail%2C%20soft%20lighting&width=200&height=200&seq=avatar-03&orientation=squarish", text: "页面干净好浏览，没有乱七八糟的广告，内容质量很高，是我目前最喜欢的动漫导航站。" },
];

const milestones = [
  { year: "2018", title: "动漫网创立", desc: "从一个小小的动漫收藏夹开始，为爱好动漫的朋友提供直达导航。" },
  { year: "2020", title: "八大分类上线", desc: "完成热血、恋爱、治愈、科幻等八大频道的搭建，内容体系初具规模。" },
  { year: "2023", title: "百万用户", desc: "累计服务用户突破百万，成为备受喜爱的动漫门户之一。" },
  { year: "2026", title: "全新升级", desc: "全面优化直达链接与浏览体验，开启动漫资讯新篇章。" },
];

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于我们 - 动漫网",
    url: "https://animelist8.github.io/about",
    description: "动漫网是一个专注动漫导航与资讯的中文门户网站，聚合全频道分类、热门新番与最新资讯。",
    inLanguage: "zh-CN",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "动漫网",
    url: "https://animelist8.github.io/",
    description: "专注动漫导航与资讯的中文门户网站",
    foundingDate: "2018",
    email: "service@dongmanwang.com",
    telephone: "400-888-6666",
    address: { "@type": "PostalAddress", streetAddress: "动漫产业园区 A 座 301 室", addressLocality: "上海", addressCountry: "CN" },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "动漫网", item: "https://animelist8.github.io/" },
      { "@type": "ListItem", position: 2, name: "关于我们" },
    ],
  },
];

export default function About() {
  return (
    <>
      <Seo
        title="关于我们 - 动漫网"
        description="了解动漫网：一个专注动漫导航与资讯的中文门户网站。查看品牌介绍、发展里程碑、用户口碑与联系方式。"
        keywords="动漫网,关于我们,品牌介绍,动漫门户,联系方式"
        canonical="/about"
        jsonLd={jsonLd}
      />

      <section className="relative overflow-hidden bg-primary-600 pt-24 md:pt-28">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20anime%20pattern%20of%20floating%20sparkles%20stars%20and%20gentle%20waves%20in%20warm%20coral%20and%20cream%20tones%2C%20soft%20decorative%20artistic%20illustration%2C%20high%20detail%2C%20clean%20elegant%20background&width=1600&height=700&seq=about-hero&orientation=landscape"
            alt="动漫网品牌背景"
            title="动漫网品牌背景"
            className="h-full w-full object-cover"
          />
        </div>
        <div className="relative mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
          <Breadcrumbs items={[{ label: "动漫网", to: "/" }, { label: "关于我们" }]} />
          <h1 className="mt-5 font-heading text-3xl text-background-50 md:text-5xl">关于动漫网</h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-primary-100 md:text-lg">
            一个专注动漫导航与资讯的中文门户网站。聚合全频道分类、热门新番与最新资讯，为动漫爱好者打造一站式导航体验。
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
                <i className="ri-rocket-2-fill"></i> 品牌故事
              </span>
              <h2 className="mt-4 font-heading text-2xl text-foreground-900 md:text-3xl">我们因热爱而聚集</h2>
              <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
                动漫网的诞生，源于一群资深动漫爱好者的共同愿望：让每一个喜欢动漫的人，都能用最简单的方式，找到自己想看的内容。我们深知，在浩如烟海的动漫世界里，找到一部合心意的作品并不容易。
              </p>
              <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
                因此，我们打造了聚合全频道分类的导航体系与持续更新的资讯内容，并提供直达链接与收藏指引，让你"收藏一次、随时访问"。八年多来，动漫网始终坚持"内容优质、快速直达"的初心，陪伴一代又一代动漫爱好者。
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {["专业", "真诚", "高效", "热爱"].map((tag) => (
                  <span key={tag} className="inline-flex items-center whitespace-nowrap rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-medium text-secondary-700">
                    <i className="ri-checkbox-circle-line mr-1"></i>{tag}
                  </span>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {values.map((v) => (
                <div key={v.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${v.color}`}>
                    <i className={`${v.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-4 text-sm font-semibold text-foreground-900 md:text-base">{v.title}</h3>
                  <p className="mt-1.5 text-xs text-foreground-600 md:text-sm">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="text-center">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-user-star-line"></i> 用户口碑
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-900 md:text-3xl">他们眼中的动漫网</h2>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
            {reviews.map((r) => (
              <figure key={r.name} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6">
                <div className="flex gap-1 text-secondary-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-700">"{r.text}"</blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-100 pt-4">
                  <img src={r.avatar} alt={`${r.name}的头像`} title={`${r.name}`} loading="lazy" className="h-10 w-10 rounded-full object-cover" />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{r.name}</p>
                    <p className="text-xs text-foreground-500">{r.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20">
        <div className="mx-auto max-w-5xl px-4 md:px-6">
          <div className="text-center">
            <h2 className="font-heading text-2xl text-foreground-900 md:text-3xl">发展里程碑</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">八年深耕，与动漫爱好者一路同行</p>
          </div>
          <div className="relative mt-10">
            <div className="absolute left-4 top-0 h-full w-px bg-background-200 md:left-1/2 md:-translate-x-px"></div>
            <div className="space-y-8">
              {milestones.map((m, i) => (
                <div key={m.year} className={`relative flex flex-col gap-3 pl-12 md:w-1/2 md:pl-0 ${i % 2 === 0 ? "md:pr-10 md:text-right" : "md:ml-auto md:pl-10"}`}>
                  <span className={`absolute left-4 top-1 flex h-3 w-3 -translate-x-1/2 items-center justify-center rounded-full bg-accent-500 ring-4 ring-accent-100 ${i % 2 === 0 ? "md:left-auto md:right-0 md:translate-x-1/2" : "md:left-0 md:translate-x-[-50%]"}`}></span>
                  <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                    <p className="font-heading text-2xl text-accent-600">{m.year}</p>
                    <h3 className="mt-1 text-sm font-semibold text-foreground-900 md:text-base">{m.title}</h3>
                    <p className="mt-1.5 text-xs text-foreground-600 md:text-sm">{m.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <ContactSection />
    </>
  );
}